// extracted by mini-css-extract-plugin
module.exports = {"dots":"LoadingDots_dots__lY8tH","dot1":"LoadingDots_dot1__3ZY9z","dot2":"LoadingDots_dot2__1Jqb-","dot3":"LoadingDots_dot3__U5yca","jump":"LoadingDots_jump__296-N"};